import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 120000 });

export const getConfig = () => api.get("/config").then((r) => r.data);
export const analyzeIdea = (idee, business_status, audience = "gruender") =>
  api.post("/analyze", { idee, business_status, audience }).then((r) => r.data);
export const precheckIdea = (idee, business_status, audience = "gruender") =>
  api.post("/idea/precheck", { idee, business_status, audience }).then((r) => r.data);
export const getTeaser = (id) => api.get(`/report/${id}/teaser`).then((r) => r.data);
export const prepareCheckout = (report_id, buyer, sensitive_ack = false, coupon_code = "") =>
  api.post("/checkout/prepare", { report_id, buyer, origin: window.location.origin, sensitive_ack, coupon_code }).then((r) => r.data);
export const submitDetails = (report_id, details) =>
  api.post(`/report/${report_id}/details`, details).then((r) => r.data);
export const createOrder = (id, waiver_accepted = false) =>
  api.post("/payment/create-order", { report_id: id, waiver_accepted }).then((r) => r.data);
export const captureOrder = (report_id, order_id) =>
  api.post("/payment/capture-order", { report_id, order_id }).then((r) => r.data);
export const createStripeSession = (report_id, waiver_accepted = false) =>
  api.post("/payment/stripe/create-session", { report_id, origin: window.location.origin, waiver_accepted }).then((r) => r.data);
export const getStripeStatus = (session_id) =>
  api.get(`/payment/stripe/status/${session_id}`).then((r) => r.data);
export const getFullReport = (id) =>
  api.get(`/report/${id}/full`).then((r) => r.data);
export const pdfUrl = (id) => `${API}/report/${id}/pdf`;
export const createInvoice = (report_id, buyer) =>
  api.post("/invoice/create", { report_id, buyer, origin: window.location.origin }).then((r) => r.data);
export const getInvoice = (report_id) =>
  api.get(`/invoice/${report_id}`).then((r) => r.data);
export const invoicePdfUrl = (report_id) => `${API}/invoice/${report_id}/pdf`;
export const submitFeedback = (payload) => api.post("/feedback", payload).then((r) => r.data);

// --- Coupons (public) ---
export const validateCoupon = (code, audience = "gruender") =>
  api.get(`/coupon/validate`, { params: { code, audience } }).then((r) => r.data);
export const redeemCoupon = (payload) =>
  api.post("/coupon/redeem", { ...payload, origin: window.location.origin }).then((r) => r.data);

// --- Admin (httpOnly cookie auth; browser sends the cookie automatically) ---
const adminCfg = { withCredentials: true };
export const adminLogin = (password) => api.post("/admin/login", { password }, adminCfg).then((r) => r.data);
export const adminLogout = () => api.post("/admin/logout", {}, adminCfg).then((r) => r.data);
export const adminListCoupons = () =>
  api.get("/admin/coupons", adminCfg).then((r) => r.data);
export const adminCreateCoupon = (payload) =>
  api.post("/admin/coupons", payload, adminCfg).then((r) => r.data);
export const adminCreateBulkCoupons = (payload) =>
  api.post("/admin/coupons/bulk", payload, adminCfg).then((r) => r.data);
export const adminToggleCoupon = (code) =>
  api.post(`/admin/coupons/${code}/toggle`, {}, adminCfg).then((r) => r.data);
export const adminDeleteCoupon = (code) =>
  api.delete(`/admin/coupons/${code}`, adminCfg).then((r) => r.data);
